module.exports = __webpack_public_path__ + "static/media/5_cochinshipyard.45813266.svg";